import API from "../request/api";
import request from "../request/request";

const interviewService = {
  getInterviewsList(params) {
    return request.get(API.interviews, params);
  },
  getInterviewMyList(params) {
    return request.get(API.interviewMy, params);
  },
  interviewGrab(uuid) {
    return request.post(API.interviewGrab(uuid));
  },
  getInterviewInfo(uuid) {
    return request.get(API.interviewInfo(uuid));
  },
  interviewResult(uuid, params) {
    return request.post(API.interviewResult(uuid), params);
  }
  // interviewInfo
};

export default interviewService;
